module.exports = __webpack_public_path__ + "629a55a7e793da068dc580d184cc0e31.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans/OpenSans-Regular.ttf
// module id = 255
// module chunks = 0